import { render, staticRenderFns } from "./fire-dialog.vue?vue&type=template&id=d1463c24&scoped=true&"
import script from "./fire-dialog.vue?vue&type=script&lang=js&"
export * from "./fire-dialog.vue?vue&type=script&lang=js&"
import style0 from "./fire-dialog.vue?vue&type=style&index=0&id=d1463c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1463c24",
  null
  
)

export default component.exports